import { Card } from '@mui/material';
import { ReactNode } from 'react';

export function CardChart({children}:{children: ReactNode}) {
    return <Card style={{ padding: 10, height: '100%', boxSizing: 'border-box' }} elevation={2}>
        {children}
    </Card>;
}